import { Terminal, Package, Database, Cloud } from 'lucide-react'

const tools = [
  {
    name: 'tchcash',
    description: 'MCP server that handles wallet and payments',
    icon: Terminal,
    commands: ['npm install -g tchcash', 'npx tchcash'],
  },
  {
    name: 'fetch',
    description: 'Make HTTP requests with automatic payment',
    icon: Package,
    commands: ['fetch_market_data', 'fetch_weather', 'fetch_url'],
  },
  {
    name: 'check_balance',
    description: 'Check TCH balance in your wallet',
    icon: Database,
    commands: ['check_balance'],
  },
  {
    name: 'mppx',
    description: 'MPP SDK for handling 402 payments',
    icon: Cloud,
    commands: ['@modelcontextprotocol/sdk'],
  },
]

export function Tools() {
  return (
    <section className="py-24 md:py-32 bg-foreground/2">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-sentient mb-8">
            <span className="text-primary italic">Tools</span> & APIs
          </h2>
          <p className="text-lg text-foreground/60 leading-relaxed">
            Everything you need to start using paid APIs with your AI agent
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {tools.map((tool, index) => (
            <div
              key={index}
              className="border border-foreground/10 rounded-lg p-6 hover:border-primary/50 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                  <tool.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold mb-2">{tool.name}</h3>
                  <p className="text-sm text-foreground/60 mb-4 leading-relaxed">
                    {tool.description}
                  </p>
                  <div className="space-y-2">
                    {tool.commands.map((cmd, idx) => (
                      <code
                        key={idx}
                        className="block text-xs bg-foreground/5 px-2 py-1 rounded font-mono"
                      >
                        {cmd}
                      </code>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Available APIs */}
        <div className="mt-20 border border-foreground/10 rounded-lg p-8">
          <h3 className="text-xl font-semibold mb-6 text-center">Available APIs</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { endpoint: '/api/v1/market', price: '$0.01', desc: 'Crypto market data' },
              { endpoint: '/api/v1/weather', price: '$0.005', desc: 'Weather data' },
              { endpoint: '/api/v1/data', price: '$0.01', desc: 'Sample data' },
              { endpoint: '/api/v1/generate', price: '$0.05', desc: 'Generate content' },
              { endpoint: '/api/proxy/llm', price: '$0.10', desc: 'LLM API proxy' },
              { endpoint: '/api/proxy/image', price: '$0.02', desc: 'Image proxy' },
            ].map((api, idx) => (
              <div
                key={idx}
                className="border border-foreground/10 rounded p-4 hover:border-primary/50 transition-colors"
              >
                <code className="text-xs font-mono text-primary block mb-1">
                  {api.endpoint}
                </code>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-foreground/60">{api.desc}</span>
                  <span className="text-xs font-mono text-foreground/40">{api.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
